import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import * as PropTypes from "prop-types";
import { MapVendorModel} from "../../Models/vendors/VendorModel";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import "./_style.scss";
import settings from "../../configs/appSettings";
import MarkerClustererPlus from '@google/markerclustererplus';
import {SmallLoader} from "Ncontracts.Common.UI";

class VendorConcentrationMap extends Component {
    static propTypes = {
        center: PropTypes.object,
        vendorList: PropTypes.arrayOf(PropTypes.shape(MapVendorModel)),
        zoom: PropTypes.number,
        activeMapOverlayId: PropTypes.number,
        renderMapOverlay: PropTypes.func,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ])
    };

    static defaultProps = {
        center: {lat: 39.82, lng: -98.57},
        zoom: 5,
    };

    constructor(props) {
        super(props);
        this.infoWindow = undefined;
        this.map = undefined;
        this.maps = undefined;
        this.LatLngBounds = undefined;
        this.LatLng = undefined;
        this.markerClusterer = undefined;
        this.markerDots = undefined;

        this.state = {
            isLoading: true
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps === undefined)
        return;

        if (this.props.vendorList === undefined)
        return;

        if (prevProps.vendorList === undefined) {
            this.renderClusters();
        } else if (prevProps.vendorList.length !== this.props.vendorList.length) {
            this.clearClusters();
            this.renderClusters();
        }

        const layerChanged = this.props.activeMapOverlayId != prevProps.activeMapOverlayId;

        if (this.map !== undefined && layerChanged) {
            this.setState({isLoading: true});
            this.clearMapOverlay();
            this.props.renderMapOverlay(this.map, this.maps);
        }
    }

    apiIsLoaded = (map, maps) => {
        const closure = this;
        closure.map = map;
        closure.maps = maps;

        closure.infoWindow = new maps.InfoWindow({
            pixelOffset: new closure.maps.Size(0, -16)
        });
        closure.LatLngBounds = new maps.LatLngBounds();
        closure.map.addListener('idle', () => {
            closure.setState({ isLoading: false });
        });

        this.props.renderMapOverlay(this.map, this.maps);
        this.renderClusters();
    };

    renderClusters = () => {

        if (this.props.vendorList === undefined || this.props.vendorList.length < 1 || this.maps === undefined)
            return;

        const closure = this;

        const dots = this.props.vendorList.map(buildMapMarker);
        closure.markerDots = dots;

        this.attachMouseoverTooltipsToMarkers(closure.markerDots);
        this.renderMarkerCluster(closure.markerDots);

        function buildMapMarker(vendor) {
            return new closure.maps.Marker({
                position: {
                    lat: +offset(vendor.latitude),
                    lng: +offset(vendor.longitude)
                },
                icon: {
                    url: `${imageCdnUrls.map_marker_png}`,
                    origin: new closure.maps.Point(0, 0),
                    anchor: new closure.maps.Point(13, 13),
                    scaledSize: new closure.maps.Size(25, 25)
                },
                locationName: vendor.name,
                locationAddress: vendor.address1,
                locationCity: vendor.city,
                locationState: vendor.state,
                locationPostalCode: vendor.postalCode,
                residualRiskName: vendor.residualRiskName,
                inherentRiskName: vendor.inherentRiskName
            });
        }

        function offset(coordinate) {
            return parseFloat(coordinate) + (Math.random() - .5) / 1500;
        }
    };

    renderMarkerCluster(markerDots) {
        const closure = this;
        let clusterStyles = [
            {
                textColor: 'white',
                height: 30,
                width: 30,
                fontFamily: "Open Sans",
                className: 'custom-clustericon-1'
            },
            {
                textColor: 'white',
                height: 30,
                width: 30,
                fontFamily: "Open Sans",
                className: 'custom-clustericon-2'
            },
            {
                textColor: 'white',
                height: 40,
                width: 40,
                fontFamily: "Open Sans",
                className: 'custom-clustericon-3'
            }
        ];


        closure.markerClusterer = new MarkerClustererPlus(closure.map, markerDots, {
            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
            gridSize: 10,
            minimumClusterSize: 2,
            averageCenter: true,
            styles: clusterStyles,
            clusterClass: 'custom-clustericon',
            maxZoom: 18
        });
    }

    clearClusters = () => {
        const closure = this;

        for (let i = 0; i < closure.markerDots.length; i++) {
            closure.markerDots[i].setMap(null);
        }
        closure.markerDots = [];
        closure.markerClusterer.setIgnoreHidden(true);
        closure.markerClusterer.clearMarkers();
    };

    attachMouseoverTooltipsToMarkers(markers) {
        const closure = this;
        markers.forEach(function (marker) {
            marker.addListener('mouseover', function () {
                const infoWindowContent = closure.buildInfoContent(marker);

                closure.infoWindow.setContent(infoWindowContent);
                closure.infoWindow.setPosition(marker.position);
                closure.infoWindow.open(closure.map);

                marker.addListener('mouseout', function () {
                    closure.infoWindow.close();
                });

            });
        });
    }

    clearMapOverlay = () => {
        let closure = this;
        if (this.map !== undefined) {
            this.map.data.forEach(function (feature) {
                closure.map.data.remove(feature);
            });
        }
    };

    buildInfoContent = (marker) => {
        const residualRiskName = marker.residualRiskName != null
            && marker.residualRiskName !== undefined
            ? marker.residualRiskName
            : "";

        const inherentRiskName = marker.inherentRiskName != null
            && marker.inherentRiskName !== undefined
            ? marker.inherentRiskName
            : "";


        const inherentRiskLine = marker.inherentRiskName !== null
            && marker.inherentRiskName !== undefined
            ? `<div class="iw-riskLevel-content">Inherent Risk Level: ${inherentRiskName}</div>`
            : "";

        const residualRiskLine = marker.residualRiskName !== null
            && marker.residualRiskName !== undefined
            ? `<div class="iw-riskLevel-content">Residual Risk Level: ${residualRiskName}</div>`
            : "";

        const infoWindowContent = (
            `<div id="iw-vendor-container">
                <div class="iw-vendor-title">${marker.locationName}</div>
                <div class="iw-vendor-content">${marker.locationAddress}</div>
                <div class="iw-vendor-content">${marker.locationCity} , ${marker.locationState} + ${marker.locationPostalCode}</div>
                ${residualRiskLine}
                ${inherentRiskLine}
            </div>`
        );

        return infoWindowContent;
    }

    render() {
        const {isLoading} = this.state;
        return (
            <div className="map-wrapper">
                <div className="vendorConcentrationMap">
                    {isLoading && <div className="loading-overlay">
                        <SmallLoader/>
                    </div>}
                    <GoogleMapReact
                        bootstrapURLKeys={{
                            key: `${settings.googleMapsApiKey}`,
                            language: 'en',
                            libraries: 'places, geometry',
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
                        defaultCenter={this.props.center || {lat: 39.82, lng: -98.57}}
                        defaultZoom={this.props.zoom}
                    />
                    {/* I'd really love to be passing a child component to GoogleMapReact for the Markers, but still need the clustering logic I think */}
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default VendorConcentrationMap;
